import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { PRIMARY } from '../../components/LmsSectionCard';
import LmsNewsPhoto from './LmsNewsPhoto';
import LmsNewsBadges from './LmsNewsBadges';
import { formatLocalDateTime, getNewsTitle, isAnnouncement } from '../utils/newsUtils';

const MetaItem = ({ icon, text }) => (
    <span className="flex align-items-center gap-2 text-sm text-color-secondary" style={{ minWidth: 0 }}>
        <i className={`pi ${icon}`} style={{ fontSize: '0.85rem' }} />
        <span className="white-space-nowrap overflow-hidden text-overflow-ellipsis">{text}</span>
    </span>
);

const LmsNewsCard = ({ news }) => {
    const { th } = useLanguage();
    const announcement = isAnnouncement(news);
    const detailPath = `/learning-management-system/news/${news.id}`;

    return (
        <div className="col-12 sm:col-6 lg:col-4 xl:col-3">
            <div className="border-round-xl overflow-hidden h-full flex flex-column" style={{ border: '1px solid #EAECF0', backgroundColor: '#FFFFFF', boxShadow: '0 1px 2px rgba(16,24,40,0.04)' }}>
                <Link to={detailPath} className="block no-underline">
                    <LmsNewsPhoto news={news} style={{ aspectRatio: '16 / 9' }}>
                        <LmsNewsBadges news={news} className="absolute top-0 left-0 m-3" />
                    </LmsNewsPhoto>
                </Link>

                <div className="p-3 flex flex-column gap-2 flex-grow-1">
                    <Link to={detailPath} className="no-underline font-semibold" style={{ color: '#101828', fontSize: '1rem', lineHeight: 1.35 }}>
                        {getNewsTitle(news)}
                    </Link>

                    {announcement ? (
                        news.publishDate && <MetaItem icon="pi-calendar" text={formatLocalDateTime(news.publishDate)} />
                    ) : (
                        <>
                            <div className="flex align-items-center gap-3 flex-wrap">
                                {news.planningLocationText && <MetaItem icon="pi-map-marker" text={news.planningLocationText} />}
                                {news.trainingCapacity != null && <MetaItem icon="pi-users" text={th('lmsNews.participants', { count: news.trainingCapacity })} />}
                            </div>
                            {news.trainingTypeText && <MetaItem icon="pi-cog" text={news.trainingTypeText} />}
                        </>
                    )}

                    {news.shortDescription && (
                        <span className="text-sm" style={{ color: '#475467', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                            {news.shortDescription}
                        </span>
                    )}

                    <div className="flex justify-content-end mt-auto pt-2">
                        <Link to={detailPath} className="no-underline text-sm font-semibold flex align-items-center gap-2" style={{ color: PRIMARY }}>
                            {th('lmsNews.viewDetails')}
                            <i className="pi pi-arrow-right" style={{ fontSize: '0.8rem' }} />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LmsNewsCard;
